import {
  setUnauthorizedHandler,
  setAccessToken,
  clearAccessToken,
} from "./apiClient";
import clinicAPI from "./clinicApi";
import authAPI from "./authApi";

const services = {
  setUnauthorizedHandler,
  persistAccessToken: setAccessToken,
  clearAccessToken,
  clinicAPI,
  authAPI,
};

export default services;
